import React from 'react';
import { ButtonWithAnchor } from '../hero-section/sticky-button';
import { ButtonVariants } from '../../../Atoms/Button';
import { FILING_LINK } from '../../static/data';

const WhyWaitBanner = () => {
  return (
    <div className="wg-container pt-6 pb-32">
      <div
        className="w-full rounded-3xl h-[362px]"
        style={{
          backgroundImage: `url('https://assets.clear.in/cleartax/images/1757598352_frame2147224660.webp')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'left',
          backgroundSize: 'contain',
        }}
      >
        <div className="w-2/5 pl-16 pt-28 pb-24">
          <div className="text-s-40 lg:text-s-32 font-semibold text-white pb-4">
            Why wait to get Maximum tax refund?
          </div>
          <div className="w-1/2">
            <ButtonWithAnchor
              buttonText={'File now in 3 mins'}
              trackLabel={'in_page'}
              buttonLink={FILING_LINK}
              buttonVariant={ButtonVariants.bluefilled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyWaitBanner;
